import { trpc } from '@/data-loaders';
import { useAuth } from 'react-oidc-context';

export const useGetEmbeddedURL = () => {
  const auth = useAuth();

  const staffId = (auth.user?.profile['uid'] as string) ?? auth.user?.profile.sub;

  return trpc.getEmbeddedURL.useQuery(
    { staffId },
    {
      enabled: !!staffId,
      refetchOnMount: true,
    },
  );
};
